import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useAuth } from "../context/auth";
import { Header2 } from "../components/elements/Header";
import axios from "axios";
import authHeader from "../services/auth.header";
import { useForm } from "react-hook-form";
import Popup from "reactjs-popup";
import moment from "moment";
import bmale1 from "../assets/svg/bshape/bmale1.svg";
import bmale1true from "../assets/svg/bshape/bmale1true.svg";
import bmale2true from "../assets/svg/bshape/bmale2true.svg";
import bmale3true from "../assets/svg/bshape/bmale3true.svg";
import bmale4true from "../assets/svg/bshape/bmale4true.svg";
import bmale5true from "../assets/svg/bshape/bmale5true.svg";
import bmale2 from "../assets/svg/bshape/bmale2.svg";
import bmale3 from "../assets/svg/bshape/bmale3.svg";
import bmale4 from "../assets/svg/bshape/bmale4.svg";
import bmale5 from "../assets/svg/bshape/bmale5.svg";
import checked from "../assets/svg/checked.svg";
import { navigate } from "@reach/router";

export const SmallBtn = styled.button`
  background: #171111;
  box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.35),
    -5px -5px 25px rgba(56, 56, 56, 0.3);
  border-radius: 24px;
  border: none;
  width: 54px;
  height: 117px;
`;

export const SvgImg2 = styled.img`
  height: 14vh;
`;

export const NextBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

export const CircleBtn = styled.button`
  border-radius: 24px;
  border: none;
  width: 45px;
  height: 45px;
  &:focus {
    background: #261c1c;
  }
`;

export const SvgImg3 = styled.img`
  background: rgba(4, 3, 3, 0.5);
  border-radius: 50%;
  width: 29px;
  height: 29px;
`;

const Text = styled.h1`
  width: 172px;
  height: 40px;
  font-family: Poppins;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #fffcf2;
`;

const SetupBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 16px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

const LblWrapper = styled.div`
  width: 150px;
`;

const Label = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 10px;
`;

const Desc = styled.p`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 10px;
`;

const Edit = styled.p`
  font-family: Poppins;
  color: #fdfffc;
  font-size: 16px;
  margin-top: 30px;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #f89825;
  text-decoration-thickness: 2px;
  &:hover {
    color: #fd9e46;
    cursor: pointer;
  }
`;

const DisEdit = styled.p`
  font-family: Poppins;
  opacity: 0.5;
  color: #fdfffc;
  font-size: 16px;
  margin-top: 30px;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #f89825;
  text-decoration-thickness: 2px;
  &:hover {
    cursor: pointer;
  }
`;

const LabelSvg = styled.img`
display: block;
top: 0;
left: 0;
overflow: visible;
width: 163px;
height: 297px;
}
`;

const StyledPopup = styled(Popup)`
  &-overlay {
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: rgba(4, 3, 3, 0.7);
  }
  &-content {
    position: absolute;
    color: #fdfffc;
    top: auto !important;
    bottom: 0px !important;
    overflow: auto;
    right: auto;
    width: 100%;
    left: 0px !important;
    border-radius: 20px;
    outline: none;
    padding-bottom: 10px;
    background-color: #040303;
    padding: 5px;
  }
`;

const NotiWrapper = styled.div`
  width: 152px;
  height: 48px;
  border-radius: 5px;
  background-color: #2f2323;
`;

const NotiText = styled.p`
  overflow: auto;
  font-family: Poppins;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: center;
  color: #fffcf2;
`;

const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

const FormLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
`;

const Header = styled.h1`
  margin-top: 20px;
  margin-left: 14px;
  font-family: PlayfairDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
`;

export default function BodyTrait(props) {
  const BASE_URL = "https://catway.services.ombre.app/v1/";
  const { user } = useAuth();
  const [bodyProfile, setBodyProfile] = useState(null);
  const [shape, setShape] = useState("default");
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState("");
  const [tone, setTone] = useState("default");
  const [body1, setBody1] = useState(false);
  const [body2, setBody2] = useState(false);
  const [body3, setBody3] = useState(false);
  const [body4, setBody4] = useState(false);
  const [body5, setBody5] = useState(false);
  const [skin1, setSkin1] = useState(false);
  const [skin2, setSkin2] = useState(false);
  const [skin3, setSkin3] = useState(false);
  const [skin4, setSkin4] = useState(false);
  const [skin5, setSkin5] = useState(false);
  const [skin6, setSkin6] = useState(false);
  const [skin7, setSkin7] = useState(false);
  const [skin8, setSkin8] = useState(false);
  const [skin9, setSkin9] = useState(false);
  const [heightValue, setHeightValue] = useState(70);
  const [weightValue, setWeightValue] = useState(70);
  const [isUpdating, setIsUpdating] = useState(false);
  const {
    watch,
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    // resolver: yupResolver(schema),
  });

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = () => {
    return axios
      .get(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profile",
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setBodyProfile(response.data);
        setShape(response.data.data.bodyShape);
        setHeight(response.data.data.height);
        setHeightValue(response.data.data.height);
        setWeight(response.data.data.weight);
        setWeightValue(response.data.data.weight);
        setTone(response.data.data.skinTone);
      });
  };

  const updateTrait = () => {
    if (bodyProfile && bodyProfile.data.unit === "metric") {
      return axios.put(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profiles/" +
          bodyProfile.data.id,
        {
          unit: "metric",
          height: height,
          weight: weight,
          skinTone: tone,
          bodyShape: shape,
        },
        {
          headers: authHeader(),
        }
      );
    } else {
      return axios.put(
        BASE_URL + "users/" + user.data.id + "/profiles/" + bodyProfile.data.id,
        {
          unit: "us",
          height: { feet: height.feet, inch: height.inch },
          weight: weight,
          skinTone: tone,
          bodyShape: shape,
        },
        {
          headers: authHeader(),
        }
      );
    }
  };

  const renderDate = () => {
    if (bodyProfile) {
      let now = new Date(bodyProfile.data.nextUpdate);
      var date = moment(now).format("Do MMM  YY");
      return date;
    } else {
      return <></>;
    }
  };

  const renderUs = () => {
    if (bodyProfile && bodyProfile.unit != "metric") {
      return (
        <Desc>
          {bodyProfile.data.height.feet}'{bodyProfile.data.height.inch}"
        </Desc>
      );
    }
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <Header2 style={{ marginTop: "70px" }}>Body Traits</Header2>
      {!bodyProfile && (
        <div
          style={{
            padding: "15px",
            background: "#040303",
            marginTop: "24px",
          }}
          className="d-flex justify-content-between"
        >
          <div>
            <Text>
              You have not setup your body traits yet. Set them up now!
            </Text>
          </div>
          <div>
            <SetupBtn>Setup body Traits</SetupBtn>
          </div>
        </div>
      )}
      {isUpdating && (
        <div
          style={{
            padding: "15px",
            background: "#040303",
            marginTop: "24px",
          }}
          className="d-flex justify-content-between"
        >
          <div>
            <Text style={{ marginLeft: "35px" }}>
              You have adjusted your trait! Submit now.
            </Text>
          </div>
          <div>
            <SetupBtn style={{ marginRight: "30px" }} onClick={updateTrait}>
              Submit
            </SetupBtn>
          </div>
        </div>
      )}
      <div style={{ marginTop: "40px" }}>
        <LblWrapper
          style={{ position: "relative", left: "60px", right: "50px" }}
          className="d-flex justify-content-between"
        >
          <div>
            <Label>Body Shape:</Label>
            {bodyProfile ? <Desc>{capitalize(shape)}</Desc> : <Desc>-</Desc>}
          </div>
          <div>
            {bodyProfile && bodyProfile.data.nextUpdate === null ? (
              <StyledPopup
                trigger={<Edit>Edit</Edit>}
                closeOnEscape
                arrow="false"
              >
                {(close) => (
                  <>
                    {" "}
                    <div className="d-flex justify-content-center">
                      <Header style={{ marginTop: "5px" }}>Body Shape</Header>
                    </div>
                    <>
                      <form>
                        <div className="d-flex justify-content-between px-3 mb-5">
                          <input
                            style={{ display: "none" }}
                            {...register("bodyShape", {
                              required: true,
                            })}
                          ></input>
                          <SmallBtn
                            onClick={(e) => {
                              e.preventDefault();
                              setBody1(true);
                              setBody2(false);
                              setBody3(false);
                              setBody4(false);
                              setBody5(false);
                              setValue("bodyShape", "slender", {
                                shouldValidate: true,
                                shouldDirty: true,
                              });
                            }}
                          >
                            <SvgImg2 src={body1 ? bmale1true : bmale1} />
                          </SmallBtn>
                          <SmallBtn
                            onClick={(e) => {
                              e.preventDefault();
                              setBody1(false);
                              setBody2(true);
                              setBody3(false);
                              setBody4(false);
                              setBody5(false);
                              setValue("bodyShape", "rectangle", {
                                shouldValidate: true,
                                shouldDirty: true,
                              });
                            }}
                          >
                            <SvgImg2 src={body2 ? bmale2true : bmale2} />
                          </SmallBtn>
                          <SmallBtn
                            onClick={(e) => {
                              e.preventDefault();
                              setBody1(false);
                              setBody2(false);
                              setBody3(true);
                              setBody4(false);
                              setBody5(false);
                              setValue("bodyShape", "triangle", {
                                shouldValidate: true,
                                shouldDirty: true,
                              });
                            }}
                          >
                            <SvgImg2 src={body3 ? bmale3true : bmale3} />
                          </SmallBtn>
                          <SmallBtn
                            onClick={(e) => {
                              e.preventDefault();
                              setBody1(false);
                              setBody2(false);
                              setBody3(false);
                              setBody4(true);
                              setBody5(false);
                              setValue("bodyShape", "muscular", {
                                shouldValidate: true,
                                shouldDirty: true,
                              });
                            }}
                          >
                            <SvgImg2 src={body4 ? bmale4true : bmale4} />
                          </SmallBtn>
                          <SmallBtn
                            onClick={(e) => {
                              e.preventDefault();
                              setBody1(false);
                              setBody2(false);
                              setBody3(false);
                              setBody4(false);
                              setBody5(true);
                              setValue("bodyShape", "oval", {
                                shouldValidate: true,
                                shouldDirty: true,
                              });
                            }}
                          >
                            <SvgImg2 src={body5 ? bmale5true : bmale5} />
                          </SmallBtn>
                        </div>
                        <NextBtn
                          onClick={(e) => {
                            e.preventDefault();
                            setShape(getValues("bodyShape"));
                            setIsUpdating(true);
                            close();
                          }}
                        >
                          Update
                        </NextBtn>
                      </form>
                    </>
                  </>
                )}
              </StyledPopup>
            ) : (
              <DisEdit>Edit</DisEdit>
            )}
          </div>
        </LblWrapper>
        {bodyProfile && (
          <LblWrapper
            style={{ position: "relative", left: "60px", right: "50px" }}
          >
            {bodyProfile.data.nextUpdate === !null && (
              <NotiWrapper>
                <NotiText>
                  You'll be able to edit body shape on {renderDate()}.
                </NotiText>
              </NotiWrapper>
            )}
          </LblWrapper>
        )}
        <div className="d-flex justify-content-between">
          <LblWrapper style={{ marginTop: "50px", marginLeft: "25px" }}>
            <div>
              <Label>Height:</Label>
              {bodyProfile ? (
                <>
                  {bodyProfile && bodyProfile.data.unit != "metric" ? (
                    <>
                      <Desc>{renderUs()}</Desc>
                    </>
                  ) : (
                    <Desc>{height} cm</Desc>
                  )}
                </>
              ) : (
                <Desc>-</Desc>
              )}
            </div>
            <div>
              {bodyProfile && bodyProfile.data.nextUpdate === null ? (
                <StyledPopup
                  trigger={<Edit style={{ marginTop: "10px" }}>Edit</Edit>}
                  closeOnEscape
                  arrow="false"
                >
                  {(close) => (
                    <>
                      <div className="d-flex justify-content-center">
                        <Header style={{ marginTop: "5px" }}>Height</Header>
                      </div>
                      {bodyProfile.data.unit === "metric" ? (
                        <>
                          <div className="mt-3">
                            <FormLabel>Height:</FormLabel>
                          </div>
                          <div style={{ marginBottom: "25px" }}>
                            <FormInput
                              value={heightValue}
                              onChange={(e) => setHeightValue(e.target.value)}
                            />
                          </div>
                          <NextBtn
                            onClick={() => {
                              setHeight(heightValue);
                              setIsUpdating(true);
                              close();
                            }}
                          >
                            Update
                          </NextBtn>
                        </>
                      ) : (
                        <>
                          <div className="mt-3">
                            <FormLabel>Feet:</FormLabel>
                          </div>
                          <div style={{ marginBottom: "25px" }}>
                            <FormInput
                              value={heightValue.feet}
                              onChange={(e) => setHeightValue(e.target.value)}
                            />
                          </div>
                          <div className="mt-3">
                            <FormLabel>Inch:</FormLabel>
                          </div>
                          <div style={{ marginBottom: "25px" }}>
                            <FormInput
                              value={heightValue.inch}
                              onChange={(e) => setHeightValue(e.target.value)}
                            />
                          </div>
                          <NextBtn
                            onClick={() => {
                              setHeight(heightValue);
                              setIsUpdating(true);
                              close();
                            }}
                          >
                            Update
                          </NextBtn>
                        </>
                      )}
                    </>
                  )}
                </StyledPopup>
              ) : (
                <Popup
                  trigger={<DisEdit>Edit</DisEdit>}
                  on={["hover", "click"]}
                  position="bottom"
                  arrow={false}
                >
                  <NotiWrapper style={{ width: "150px", marginTop: "15px" }}>
                    <NotiText>
                      You'll be able to edit height on {renderDate()}.
                    </NotiText>
                  </NotiWrapper>
                </Popup>
              )}
            </div>
          </LblWrapper>
          {shape === "slender" && <LabelSvg src={bmale1true}></LabelSvg>}
          {shape === "rectangle" && <LabelSvg src={bmale2true}></LabelSvg>}
          {shape === "triangle" && <LabelSvg src={bmale3true}></LabelSvg>}
          {shape === "muscular" && <LabelSvg src={bmale4true}></LabelSvg>}
          {shape === "oval" && <LabelSvg src={bmale5true}></LabelSvg>}
          {shape === "default" && <LabelSvg src={bmale1}></LabelSvg>}
          <LblWrapper style={{ marginTop: "50px", marginRight: "10px" }}>
            <div>
              <Label>Skin:</Label>
              {bodyProfile ? <Desc>{capitalize(tone)}</Desc> : <Desc>-</Desc>}
            </div>
            <div>
              {bodyProfile && bodyProfile.data.nextUpdate === null ? (
                <StyledPopup
                  trigger={<Edit style={{ marginTop: "10px" }}>Edit</Edit>}
                  closeOnEscape
                  arrow="false"
                >
                  {(close) => (
                    <>
                      <div className="d-flex justify-content-center">
                        <Header style={{ marginTop: "5px" }}>Skin Tone</Header>
                      </div>
                      <>
                        <form onSubmit={handleSubmit(updateSkin)}>
                          <div className="d-flex justify-content-between px-3">
                            <input
                              style={{ display: "none" }}
                              {...register("skinTone", { required: true })}
                            ></input>
                            <CircleBtn
                              style={{ background: "#f4e6d0" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(true);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", "very-fair", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin1 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: " #eedabd" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(true);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", "fair", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin2 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: "#eacfa8" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(true);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", "medium", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin3 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: "#d7bb91" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(true);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", "olive", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin4 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: "#c6a57d" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(true);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", "honey", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin5 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: "#a47950" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(true);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", "brown", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin6 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                          </div>
                          <div className="d-flex justify-content-between mt-2  px-3">
                            <CircleBtn
                              style={{ background: "#7b6752" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(true);
                                setSkin8(false);
                                setSkin9(false);
                                setValue("skinTone", " dark-brown", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin7 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: " #6c4120" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(true);
                                setSkin9(false);
                                setValue("skinTone", "bronze", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin8 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn
                              style={{ background: "#23160a" }}
                              onClick={(e) => {
                                e.preventDefault();
                                setSkin1(false);
                                setSkin2(false);
                                setSkin3(false);
                                setSkin4(false);
                                setSkin5(false);
                                setSkin6(false);
                                setSkin7(false);
                                setSkin8(false);
                                setSkin9(true);
                                setValue("skinTone", "chocolate", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              {skin9 ? <SvgImg3 src={checked} /> : <></>}
                            </CircleBtn>
                            <CircleBtn style={{ background: "transparent" }} />
                            <CircleBtn style={{ background: "transparent" }} />
                            <CircleBtn style={{ background: "transparent" }} />
                          </div>
                          <NextBtn
                            style={{ marginTop: "15px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              setTone(getValues("skinTone"));
                              setIsUpdating(true);
                              close();
                            }}
                          >
                            Update
                          </NextBtn>
                        </form>
                      </>
                    </>
                  )}
                </StyledPopup>
              ) : (
                <DisEdit>Edit</DisEdit>
              )}
            </div>
          </LblWrapper>
        </div>
        {bodyProfile && (
          <LblWrapper
            style={{ position: "relative", left: "60px", right: "50px" }}
          >
            {bodyProfile.data.nextUpdate === !null && (
              <NotiWrapper>
                <NotiText>
                  You'll be able to edit body shape on {renderDate()}.
                </NotiText>
              </NotiWrapper>
            )}
          </LblWrapper>
        )}
        <LblWrapper
          style={{ position: "relative", left: "60px", right: "50px" }}
          className="d-flex justify-content-between"
        >
          <div>
            <Label>Weight:</Label>
            {bodyProfile ? (
              <>
                {bodyProfile.data.unit === "metric" ? (
                  <Desc>{weight} kg</Desc>
                ) : (
                  <Desc>{weight} lbs</Desc>
                )}
              </>
            ) : (
              <Desc>-</Desc>
            )}
          </div>
          <div>
            {bodyProfile && bodyProfile.data.nextUpdate === null ? (
              <StyledPopup
                trigger={<Edit>Edit</Edit>}
                closeOnEscape
                arrow="false"
              >
                {(close) => (
                  <>
                    <div className="d-flex justify-content-center">
                      <Header
                        style={{ marginTop: "5px", marginBottom: "50px" }}
                      >
                        Weight
                      </Header>
                    </div>
                    <>
                      <div className="mt-3">
                        <FormLabel>Weight:</FormLabel>
                      </div>
                      <div style={{ marginBottom: "25px" }}>
                        <FormInput
                          value={weightValue}
                          onChange={(e) => setWeightValue(e.target.value)}
                        />
                      </div>
                      <div style={{ marginBottom: "30px" }}>
                        <NextBtn
                          onClick={() => {
                            setWeight(weightValue);
                            setIsUpdating(true);
                            close();
                          }}
                        >
                          Update
                        </NextBtn>
                      </div>
                    </>
                  </>
                )}
              </StyledPopup>
            ) : (
              <DisEdit>Edit</DisEdit>
            )}
          </div>
        </LblWrapper>
      </div>
    </>
  );
}
